import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { GeneralPopupComponent } from "./general-popup/general-popup.component";




@NgModule({
  declarations: [GeneralPopupComponent],
  exports:[
    GeneralPopupComponent
      ],
  imports: [
    CommonModule,
    BrowserModule
  ]
})
export class GeneralPopupModule { }
